import { useMemo } from 'react';
import { getmaxAnswerableQuestions } from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';

const useTotalQuestions = () => {
  const maxAnswerableQuestionBySection = useSelectorWithShallowEqual(
    getmaxAnswerableQuestions
  );

  const totalQuestions = useMemo(
    () =>
      Object.keys(maxAnswerableQuestionBySection).reduce(
        (sum, key) => sum + (maxAnswerableQuestionBySection[key] ?? 0),
        0
      ),
    [maxAnswerableQuestionBySection]
  );

  return totalQuestions;
};

export default useTotalQuestions;
